import { LocalizedText } from '@mews/framework';
import { Stack, Body, Divider } from '@optimus-web/core';
import { TextMessagingLabel } from '../Typography';

interface RowProps {
    content: React.ReactNode;
    label: Mews.TextKey;
    messageTextKey?: Mews.TextKey;
    hasDivider?: boolean;
}

export const Row = ({ content, label, messageTextKey, hasDivider = true }: RowProps) => (
    <Stack vertical spacing="200">
        <Stack distribution="space-between" spacing="25">
            <Stack vertical spacing="50">
                <TextMessagingLabel as="p">
                    <LocalizedText textKey={label} />
                </TextMessagingLabel>
                {messageTextKey != null ? (
                    <Body size="small" variant="secondary">
                        <LocalizedText textKey={messageTextKey} />
                    </Body>
                ) : null}
            </Stack>
            <Body>{content}</Body>
        </Stack>
        {hasDivider && <Divider />}
    </Stack>
);
